export const parseHTMLScripts = (htmlString) => {
  const scripts = [];

  if (htmlString) {
    try {
      const scriptRegex = /<script(?:\s+([^>]*))?\s*>([\s\S]*?)<\/script>/gi;
      let match;

      while ((match = scriptRegex.exec(htmlString)) !== null) {
        const attributes = {};

        if (match[1]) {
          const attributeRegex = /\b([\w:-]+)\s*=\s*(['"])(.*?)\2/g;
          let attrMatch;

          while ((attrMatch = attributeRegex.exec(match[1])) !== null) {
            attributes[attrMatch[1]] = attrMatch[3];
          }
        }

        const textContent = match[2].trim();

        scripts.push({
          ...(Object.keys(attributes).length ? attributes : {}),
          ...(textContent ? { innerHTML: textContent } : {}),
        });
      }
    } catch {
      console.error('could not parse script');
    }
  }

  return { scripts, hasScript: scripts.length > 0 };
};
